
import {
    AdminImportsScreen,

    ImportsListScreen,
    ImportsValidateScreen,
    ImportCreateGenerateScreen,
    ImportCreateValidationScreen,
    ImportCreatePreviewScreen,
} from '@/screens'

export default meta => [{
    path: 'imports',
    name: 'AdminImports',
    component: AdminImportsScreen,
    redirect: { name: 'AdminImportsList' },
    meta,
    children: [
        {
            path: 'list',
            name: 'AdminImportsList',
            component: ImportsListScreen,
            meta,
        },
        {
            path: 'create/:id/generating',
            name: 'AdminImportsGenerate',
            component: ImportCreateGenerateScreen,
            meta,
        },
        {
            path: 'create/:id/validation',
            name: 'AdminImportsCreateValidation',
            component: ImportCreateValidationScreen,
            meta,
        },
        {
            path: 'create/:id/preview',
            name: 'AdminImportCreatePreview',
            component: ImportCreatePreviewScreen,
            meta,
        },
        {
            path: 'validate',
            name: 'AdminImportsValidate',
            component: ImportsValidateScreen,
            meta,
        },
    ],
}]
